import { notification } from 'antd';
import { ReactNode } from 'react';
import { NotificationsContext, TNotificationType } from './NotificationsContext';

interface IProps {
  children: ReactNode;
}

export const NotificationsContextProvider = ({ children }: IProps) => {
  const [ api, contextHolder ] = notification.useNotification();

  const showNotification = (type: TNotificationType = 'info', title: string,  description?: string) => {
    api[type]({
      title,
      description,
      placement: 'bottom',
    });
  };

  const contextValue = {
    showNotification
  };

  return (
    <NotificationsContext.Provider value={contextValue}>
      {contextHolder}
      {children}
    </NotificationsContext.Provider>
  );
};